import { UseQueryResult } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { PageUniverseDto } from "src/api/search";
import { useShop } from "src/hooks/Utils/Shop/useShop";
import { getCurrentCountry, getCurrentLanguage } from "src/utils/BasePathTools";
import { getAppEnviroment } from "src/utils/utils";

import { findUniverseByIdFromCache, findGridByIdFromCache, ViewDataLayerObject, normalizeString, AppViewDataLayerObject, pushToApps, pushToDataLayer } from "src/utils/analytics/common";


export function mainGridAnalyticMapper(
  universeQueryData: AxiosResponse<PageUniverseDto, any>, 
  universeId: number, 
  gridId: number
) {
  const country = getCurrentCountry();
  const language = getCurrentLanguage();
  const { shopId } = useShop();

  const universeData = universeQueryData?.data;
  
  if (!universeData) {
    console.error("No cached universe data available");
    return;
  }

  const universe = findUniverseByIdFromCache(universeData, universeId);
  if (!universe) {
    console.error(`Universe with id ${universeId} not found`);
    return;
  }

  const grid = findGridByIdFromCache(universe, gridId);
  if (!grid) {
    console.error(`Grid with id ${gridId} not found in universe ${universe?.name} with id ${universe?.id}`);
    return;
  }

  const universeTitle = universe?.title || "";
  const gridTitle = grid?.title || "";

  const webAnalyticsData: ViewDataLayerObject = {
    event: "front_page_view",
    data: {
      shop: normalizeString(country),
      language: normalizeString(language),
      pageType: 'PRODUCT_LIST',
      section: normalizeString(universeTitle),
      category: normalizeString(gridTitle)
    }
  };

  const appAnalyticsData: AppViewDataLayerObject = {
    eventType: "PAGE_VIEW",
    eventData: {
      store: {
        storeId: shopId,
        country: normalizeString(country),
        language: normalizeString(language),
      },
      shop: normalizeString(country),
      language: normalizeString(language),
      pageType: 'PRODUCT_LIST',
      section: normalizeString(universeTitle),
    }
  };

  getAppEnviroment() ? pushToApps(appAnalyticsData) : pushToDataLayer(webAnalyticsData);
}
